import { render, staticRenderFns } from "./ListScientific_field.vue?vue&type=template&id=d4f25c7a&scoped=true"
import script from "./ListScientific_field.vue?vue&type=script&lang=js"
export * from "./ListScientific_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f25c7a",
  null
  
)

export default component.exports